module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('van-pull-refresh', {
    on: {
      "refresh": _vm.onRefresh
    },
    model: {
      value: (_vm.isLoading),
      callback: function($$v) {
        _vm.isLoading = $$v
      },
      expression: "isLoading"
    }
  }, [_c('van-list', {
    attrs: {
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(order, index) {
    return _c('div', {
      key: index,
      staticClass: "row-list"
    }, [_c('div', {
      staticClass: "justify-space-flex row-title"
    }, [_c('div', {
      staticClass: "title-left flex-start gray"
    }, [_c('img', {
      staticClass: "row-title-img",
      attrs: {
        "src": "https://static.dierqudao.com/images/dinghuoxitong/icon-date.png",
        "alt": ""
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("timeFormat")(order.create_time)) + " 申报")])]), _vm._v(" "), _c('div', {
      staticClass: "title-right gray"
    }, [_vm._v(_vm._s(order.project))])]), _vm._v(" "), _c('div', {
      staticClass: "justify-space-flex row-goods"
    }, [_c('div', {
      staticClass: "row-left flex-start"
    }, [_c('div', {
      staticClass: "goods-detail"
    }, [_c('div', {
      staticClass: "goods-name"
    }, [_vm._v("\n                    " + _vm._s(order.name) + " (" + _vm._s(order.grade) + ")\n                    "), _c('div', [_vm._v(_vm._s(order.num))])]), _vm._v(" "), _c('div', {
      staticClass: "goods-weight gray-light"
    }, [_vm._v("\n                    性别:" + _vm._s(order.sex) + " 民族:" + _vm._s(order.minzu) + "\n                  ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row-btn"
    }, [_c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.download(order.excel_url)
        }
      }
    }, [_vm._v("下载申报表")]), _vm._v(" "), _c('div', {
      staticClass: "look-order",
      on: {
        "click": function($event) {
          return _vm.download(order.file_url)
        }
      }
    }, [_vm._v("打包资料")])])])
  }), 0)], 1), _vm._v(" "), _c('van-action-sheet', {
    attrs: {
      "actions": _vm.actions
    },
    on: {
      "select": _vm.onActionSelect
    },
    model: {
      value: (_vm.actionShow),
      callback: function($$v) {
        _vm.actionShow = $$v
      },
      expression: "actionShow"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中..."
    },
    on: {
      "click": function($event) {
        _vm.addShow = true
      }
    }
  }, [_vm._v("新增备案\n        ")])], 1), _vm._v(" "), _c('van-popup', {
    style: ({
      height: '85%'
    }),
    attrs: {
      "position": "bottom"
    },
    on: {
      "click-overlay": function($event) {
        _vm.addShow = false
      }
    },
    model: {
      value: (_vm.addShow),
      callback: function($$v) {
        _vm.addShow = $$v
      },
      expression: "addShow"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-top": "0.2rem",
      "margin-bottom": "1.5rem"
    }
  }, [_c('van-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.idChecked),
      expression: "!idChecked"
    }],
    on: {
      "submit": _vm.onIdSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("新增技术等级运动员备案")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("确定\n              ")])], 1)], 1), _vm._v(" "), _c('van-form', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.idChecked),
      expression: "idChecked"
    }],
    on: {
      "submit": _vm.onSubmit,
      "failed": _vm.onFailed
    }
  }, [_c('van-divider', [_vm._v("新增技术等级运动员备案")]), _vm._v(" "), _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "姓名",
      "rules": [{
        required: true,
        message: '姓名不能为空'
      }],
      "error-message-align": "right",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入姓名"
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.idCard,
        message: '请输入正确的身份证号'
      }],
      "error-message-align": "right",
      "label": "身份证号",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入身份证号"
    },
    model: {
      value: (_vm.formData.num),
      callback: function($$v) {
        _vm.$set(_vm.formData, "num", $$v)
      },
      expression: "formData.num"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        required: true,
        message: '单位名称不能为空'
      }],
      "label": "所属单位",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入单位名称"
    },
    model: {
      value: (_vm.formData.danwei),
      callback: function($$v) {
        _vm.$set(_vm.formData, "danwei", $$v)
      },
      expression: "formData.danwei"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "name": "area",
      "value": _vm.formData.county ? _vm.formData.province + '/' + _vm.formData.city + '/' + _vm.formData.county : '',
      "input-align": "right",
      "label": "所属地区",
      "placeholder": "点击选择省市区"
    },
    on: {
      "click": function($event) {
        _vm.showArea = true
      }
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showArea),
      callback: function($$v) {
        _vm.showArea = $$v
      },
      expression: "showArea"
    }
  }, [_c('van-area', {
    attrs: {
      "area-list": _vm.areaList,
      "value": _vm.formData.area
    },
    on: {
      "confirm": _vm.onAreaConfirm,
      "cancel": function($event) {
        _vm.showArea = false
      }
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "name": "radio",
      "label": "性别",
      "input-align": "right"
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function() {
        return [_c('van-radio-group', {
          attrs: {
            "direction": "horizontal"
          },
          model: {
            value: (_vm.formData.sex),
            callback: function($$v) {
              _vm.$set(_vm.formData, "sex", $$v)
            },
            expression: "formData.sex"
          }
        }, [_c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "男"
          }
        }, [_vm._v("男")]), _vm._v(" "), _c('van-radio', {
          attrs: {
            "checked-color": "#ffb01b",
            "name": "女"
          }
        }, [_vm._v("女")])], 1)]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "民族",
      "input-align": "right",
      "error-message-align": "right",
      "clearable": "",
      "placeholder": "请输入民族"
    },
    model: {
      value: (_vm.formData.minzu),
      callback: function($$v) {
        _vm.$set(_vm.formData, "minzu", $$v)
      },
      expression: "formData.minzu"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "个人证件照",
      "value": _vm.formData.zhengjianimg.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.zhengjianimg,
      "limit": 1,
      "name": 'zhengjianimg'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("近期个人2寸免冠相片")]), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.phone,
        message: '请输入正确的手机号'
      }],
      "error-message-align": "right",
      "label": "手机",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入手机"
    },
    model: {
      value: (_vm.formData.phone),
      callback: function($$v) {
        _vm.$set(_vm.formData, "phone", $$v)
      },
      expression: "formData.phone"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "rules": [{
        validator: _vm.validator.email,
        message: '请输入正确的邮箱'
      }],
      "error-message-align": "right",
      "label": "邮箱",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入邮箱"
    },
    model: {
      value: (_vm.formData.email),
      callback: function($$v) {
        _vm.$set(_vm.formData, "email", $$v)
      },
      expression: "formData.email"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "通级比赛时间",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入通级比赛时间"
    },
    model: {
      value: (_vm.formData.bisaidate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaidate", $$v)
      },
      expression: "formData.bisaidate"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "通级比赛地点",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入通级比赛地点"
    },
    model: {
      value: (_vm.formData.bisaididian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaididian", $$v)
      },
      expression: "formData.bisaididian"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "通级比赛名次",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入通级比赛名次"
    },
    model: {
      value: (_vm.formData.bisaichengji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bisaichengji", $$v)
      },
      expression: "formData.bisaichengji"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "个人能力测试时间",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入个人能力测试时间"
    },
    model: {
      value: (_vm.formData.chengjidate),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengjidate", $$v)
      },
      expression: "formData.chengjidate"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "个人能力测试地点",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入个人能力测试地点"
    },
    model: {
      value: (_vm.formData.chengjididian),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengjididian", $$v)
      },
      expression: "formData.chengjididian"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "error-message-align": "right",
      "label": "个人能力测试成绩",
      "input-align": "right",
      "clearable": "",
      "placeholder": "请输入个人能力测试成绩"
    },
    model: {
      value: (_vm.formData.chengji),
      callback: function($$v) {
        _vm.$set(_vm.formData, "chengji", $$v)
      },
      expression: "formData.chengji"
    }
  }), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "已有技术等级"
    },
    on: {
      "click": function($event) {
        _vm.showOldGradePicker = true
      }
    },
    model: {
      value: (_vm.formData.oldgrade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "oldgrade", $$v)
      },
      expression: "formData.oldgrade"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showOldGradePicker),
      callback: function($$v) {
        _vm.showOldGradePicker = $$v
      },
      expression: "showOldGradePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.oldGradeColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showOldGradePicker = false
      },
      "confirm": _vm.onOldGradeConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "已有项目"
    },
    on: {
      "click": function($event) {
        _vm.showOldProjectPicker = true
      }
    },
    model: {
      value: (_vm.formData.oldproject),
      callback: function($$v) {
        _vm.$set(_vm.formData, "oldproject", $$v)
      },
      expression: "formData.oldproject"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showOldProjectPicker),
      callback: function($$v) {
        _vm.showOldProjectPicker = $$v
      },
      expression: "showOldProjectPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.oldProjectColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showOldProjectPicker = false
      },
      "confirm": _vm.onOldProjectConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "现报技术等级"
    },
    on: {
      "click": function($event) {
        _vm.showGradePicker = true
      }
    },
    model: {
      value: (_vm.formData.grade),
      callback: function($$v) {
        _vm.$set(_vm.formData, "grade", $$v)
      },
      expression: "formData.grade"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showGradePicker),
      callback: function($$v) {
        _vm.showGradePicker = $$v
      },
      expression: "showGradePicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.gradeColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showGradePicker = false
      },
      "confirm": _vm.onGradeConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "readonly": "",
      "clickable": "",
      "right-icon": "arrow",
      "input-align": "right",
      "label": "现报项目"
    },
    on: {
      "click": function($event) {
        _vm.showProjectPicker = true
      }
    },
    model: {
      value: (_vm.formData.project),
      callback: function($$v) {
        _vm.$set(_vm.formData, "project", $$v)
      },
      expression: "formData.project"
    }
  }), _vm._v(" "), _c('van-popup', {
    attrs: {
      "position": "bottom"
    },
    model: {
      value: (_vm.showProjectPicker),
      callback: function($$v) {
        _vm.showProjectPicker = $$v
      },
      expression: "showProjectPicker"
    }
  }, [_c('van-picker', {
    attrs: {
      "columns": _vm.projectColumns,
      "show-toolbar": ""
    },
    on: {
      "cancel": function($event) {
        _vm.showProjectPicker = false
      },
      "confirm": _vm.onProjectConfirm
    }
  })], 1), _vm._v(" "), _c('van-field', {
    attrs: {
      "label": "近三年啦啦操参赛成绩",
      "type": "textarea",
      "input-align": "right",
      "placeholder": "从事啦啦操运动简历和主要运动成绩...",
      "rows": "2"
    },
    model: {
      value: (_vm.formData.jianli),
      callback: function($$v) {
        _vm.$set(_vm.formData, "jianli", $$v)
      },
      expression: "formData.jianli"
    }
  }), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "身份证照片",
      "value": _vm.formData.pic.length + '/2'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pic,
      "limit": 2,
      "name": 'pic'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("上传身份证正面、背面照片")]), _vm._v(" "), _c('van-cell', {
    attrs: {
      "title": "上传相关证明材料",
      "value": _vm.formData.attsrc.length + '/1'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.formData.attsrc,
      "limit": 1,
      "accept": ".rar,.zip",
      "name": 'attsrc',
      "uploadText": '上传资料'
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "operate-desc-left"
  }, [_vm._v("有效成绩证明，比赛成绩册、秩序册或获奖证书的复印件，请先打包成单个rar或zip格式的文件，然后上传")])], 1), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": "",
      "disabled": _vm.saveLoading,
      "loading": _vm.saveLoading,
      "loading-text": "提交中...",
      "native-type": "submit"
    }
  }, [_vm._v("保存\n              ")])], 1)], 1)], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3a1b5387","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/skill/LevelApplyMemberList.vue
// module id = 2332
// module chunks = 0